import { compareTo3ankvs086tmwq as compareTo } from '../js/compareTo.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function minOf(a, b) {
  return compareTo(a, b) <= 0 ? a : b;
}
function maxOf(a, b) {
  return compareTo(a, b) >= 0 ? a : b;
}
function maxOf_0(a, other) {
  var max = a;
  var inductionVariable = 0;
  var last = other.length;
  while (inductionVariable < last) {
    var e = other[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = max;
    max = Math.max(a_0, e);
  }
  return max;
}
//region block: exports
export {
  maxOf as maxOfnpw4mt1rg0hl,
  maxOf_0 as maxOf1m19db8qhkqy5,
  minOf as minOf33o15vox9quzb,
};
//endregion

//# sourceMappingURL=_ComparisonsJs.mjs.map
